import React from 'react';
import LoginView from './views/LoginView';
import { useLogin } from './hooks/Login.hook';
import { useSelector, useDispatch } from 'react-redux';
import { setUser } from '@/redux/actions/userActions';
import * as Yup from 'yup';

const LoginController = () => {
  const {
    loading,
    error,
    googleError,
    handleSubmit,
    successMessage,
    success,
    loginWithGoogleOAuth,
    showModal,
    goHome,
    goBack,
    closeModal,
    loginType,
  } = useLogin();
  const languageData = useSelector(state => state.lenguage?.lang);
  const dispatch = useDispatch();

  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(languageData === 'EN' ? 'Invalid email' : 'Email inválido')
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
    password: Yup.string()
      .min(
        6,
        languageData === 'EN' ? 'Minimum 6 characters' : 'Mínimo 6 caracteres',
      )
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
  });

  const onLogin = async values => {
    console.log('Submit values:', values);

    const tokenData = await handleSubmit(values);

    console.log('Token data recibido:', tokenData);

    if (!tokenData?.access_token) {
      dispatch(setUser(null));
      return false;
    }

    let userData = {};

    try {
      const payloadBase64 = tokenData?.access_token.split('.')[1];
      const payload = JSON.parse(atob(payloadBase64));

      userData = {
        user_id: payload.user_name || payload.user_id || payload.sub || null,
        email: payload.email || values.email,
        name: tokenData?.user_details?.user_name,
        lastName: tokenData?.user_details?.user_lastname,
        google: false,
      };
    } catch (e) {
      console.warn('No se pudo decodificar JWT:', e);
    }

    console.log('UserData a guardar en Redux:', userData);

    dispatch(setUser(userData));
    localStorage.setItem('user', JSON.stringify(userData));

    localStorage.setItem(
      'auth_data',
      JSON.stringify({
        token_type: tokenData.token_type,
        expires_in: tokenData.expires_in,
        scope: tokenData.scope,
      }),
    );

    console.log('Usuario guardado en Redux y LocalStorage');

    return true;
  };

  const handleRegister = () => {
    console.log('Redirigiendo a registro...');
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleGoogleLogin = async ({ email, googleToken }) => {
    return loginWithGoogleOAuth({ username: email, googleToken });
  };

  return (
    <LoginView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onLogin}
      success={success}
      loading={loading}
      error={error}
      googleError={googleError}
      languageData={languageData}
      onBack={handleBack}
      onRegister={handleRegister}
      successMessage={successMessage}
      onGoogleLogin={handleGoogleLogin}
      showModal={showModal}
      goHome={goHome}
      goBack={goBack}
      closeModal={closeModal}
      loginType={loginType}
    />
  );
};

export default LoginController;
